module.exports = __webpack_public_path__ + "fonts/Roboto-Thin.a732a12.ttf";